import { type ActivatedRoute } from '@angular/router';
import { PreferredLanguageEnum } from '@reconcept-platform/shared/types';

// given an ActivatedRoute, find an activated parent route that has a certain data.relativeRoutingAnchor property
// this is useful when trying to navigate relative to a known parent path from a component
// that is used in several subpaths. This way, we don't have to use absolute paths
export function parentActivatedRouteAtAnchor(activatedRoute: ActivatedRoute, anchor: string): ActivatedRoute {
  if (!activatedRoute.parent) {
    return activatedRoute;
  }

  if (activatedRoute.parent?.snapshot.routeConfig?.data?.relativeRoutingAnchor === anchor) {
    return activatedRoute.parent;
  }

  return parentActivatedRouteAtAnchor(activatedRoute.parent, anchor);
}

export function stripLanguageFromUrl(returnState: string) {
  const langMatcher = Object.values(PreferredLanguageEnum)
    .map((val) => `(/${val.toLowerCase()})/`)
    .join('|');
  const isLanguageUri = returnState.match(new RegExp(langMatcher));
  if (isLanguageUri) {
    const languageUri = isLanguageUri[0];
    return returnState.replace(languageUri, '');
  }
  return returnState;
}
